import { Abi, Address } from 'viem';
import SDAOLaunchpadABIUpdate from 'utils/constants/abi/SDAOLockedStaking.abi';

interface StakingDepositConfigParams {
  account?: Address;
  chainId?: number;
  contractAddress: Address;
  enabled: boolean;
  lockedPeriod: number;
  tokenAmount: string;
}

export const getStakingDepositConfig = ({
  account,
  chainId,
  contractAddress,
  enabled,
  lockedPeriod,
  tokenAmount,
}: StakingDepositConfigParams) => ({
  address: contractAddress,
  account,
  chainId,
  abi: SDAOLaunchpadABIUpdate as Abi,
  functionName: 'deposit' as const,
  args: [BigInt(tokenAmount), BigInt(lockedPeriod)] as const,
  query: { enabled },
});
